import StyledButton from "@/components/UI/StyledButton.vue";
import LineSeparator from "@/components/UI/LineSeparator.vue";
import DoubleImage from "@/components/UI/DoubleImage.vue";

export default [
    StyledButton, LineSeparator, DoubleImage
]
